import { render } from "./DetailPage.vue?vue&type=template&id=1edddf96&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"

import "./DetailPage.vue?vue&type=style&index=0&id=1edddf96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edddf96"]])

export default __exports__